import React from 'react';
import { withTranslation } from 'react-i18next';

import IconClose from 'icons/icon-close';
import IconArrowUp from 'icons/icon-arrow-up';

const DiscussionNotificationsBar = ({ notificationsCount, t, onClick, onClose }) => {
    if (!notificationsCount) {
        return null;
    }

    return (
        <div className="discussion-bar">
            <div className="discussion-bar-inner" onClick={onClick}>
                <IconArrowUp /> { t('Unread messages_count', {
                    count: notificationsCount
                })}
            </div>

            <button className="discussion-bar-close btn btn-small btn-simple-close" onClick={onClose}>
                <IconClose />
            </button>
        </div>
    )
}

export default withTranslation('chat')(DiscussionNotificationsBar);
